import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { joinWaitlist } from "@/lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await joinWaitlist(email);
      setState("done");
      toast.success(data.status === "exists" ? "Already on the list." : "Added to the waitlist.");
    } catch {
      setState("idle");
      toast.error("Could not add email. Try again.");
    }
  };

  return (
    <footer className="bg-[#050505]" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-6 py-20 lg:px-12">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="font-display text-4xl font-extrabold tracking-tighter">
              AXIOSERA<span className="blink" />
            </div>
            <p className="mt-6 max-w-sm font-mono text-xs leading-relaxed text-zinc-500">
              Commercial Decision Infrastructure. Delegation without loss of control.
              First product: PriceStrike.
            </p>
          </div>
          <div className="lg:col-span-6">
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
              Waitlist — get the proof numbers first
            </div>
            {state === "done" ? (
              <div className="mt-6 border border-[#00FF41]/40 px-6 py-4 font-mono text-xs text-[#00FF41]" data-testid="waitlist-success-message">
                &gt; {email} appended to waitlist ledger.
              </div>
            ) : (
              <form onSubmit={submit} className="mt-6 flex" data-testid="waitlist-form">
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  data-testid="waitlist-email-input"
                  className="w-full border border-white/10 bg-[#0F0F11] px-5 py-4 font-mono text-sm text-white placeholder:text-zinc-600 outline-none transition-colors duration-300 focus:border-[#00FF41]"
                />
                <button
                  type="submit"
                  disabled={state === "loading"}
                  data-testid="waitlist-submit-button"
                  className="shrink-0 border border-l-0 border-[#00FF41] px-6 font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] transition-colors duration-300 hover:bg-[#00FF41] hover:text-black disabled:opacity-50"
                >
                  Append
                </button>
              </form>
            )}
          </div>
        </div>
        <div className="mt-20 border-t border-white/10 pt-8">
          <div className="flex flex-col justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 lg:flex-row">
            <span data-testid="footer-copyright">© 2026 Axiosera Ltd · "Pricing Intelligence. Reimagined."</span>
            <span>Policy as code · Zero breaches · Deterministic replay</span>
            <Link to="/inbox" data-testid="footer-inbox-link" className="text-[#00FF41] transition-colors duration-300 hover:text-white">SYS: OPERATIONAL</Link>
          </div>
          <p className="mt-6 font-mono text-[11px] leading-relaxed text-zinc-700" data-testid="footer-rights">
            All rights reserved. No portion of this site may be reproduced or duplicated without the express permission of Axiosera.
          </p>
        </div>
      </div>
    </footer>
  );
}
